import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}`}
    width={`${size}`}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g fill="none" fillRule="evenodd" stroke={color} strokeWidth="2">
      <path d="M2 7h4l2-3h8l2 3h4v12H2z" />
      <circle cx="12" cy="12" r="3" />
      <path d="M23 4h-4" />
    </g>
  </svg>
);
